import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { pauseOrResumeTracking, startTracking, stopTracking } from 'actions'
import TrackingInfo from 'components/TrackingInfo'
import routes from 'config/routes'
import logo from 'images/bja-logo.svg'
import PropTypes from 'prop-types'
import React from 'react'
import { Button, Container, Nav, Navbar } from 'react-bootstrap'
import { connect } from 'react-redux'
import { Link, useHistory } from 'react-router-dom'
import { confirm } from 'utils'

function Navigation(props) {
  const {
    pauseOrResumeTracking,
    startTracking,
    stopTracking,
    tracking,
    incognito,
  } = props
  const history = useHistory()
  const [expanded, setExpanded] = React.useState()

  const logout = async () => {
    try {
      await props.onLogout()
    } catch (err) {
      console.error('Error logging out')
      console.error(err)
    }
  }

  const close = () => {
    setExpanded(false)
  }

  const track = () => {
    close()
    startTracking()
  }

  const finish = async () => {
    try {
      await confirm('Are you ready to end this session?')
      const { h: hours, m: minutes } = await stopTracking()
      history.push(routes.sessionNew, {
        session: {
          hours,
          minutes,
        },
      })
    } catch (err) {
      // no-op: user cancelled the confirm dialog
    }
  }

  return (
    <>
      <Navbar
        bg="light"
        expand="lg"
        onToggle={setExpanded}
        expanded={expanded}
        collapseOnSelect
      >
        <Container>
          <Navbar.Brand as={Link} to={routes.dashboard} onClick={close}>
            {incognito ? (
              <FontAwesomeIcon icon="home" size="lg" className="text-primary" />
            ) : (
              <img src={logo} alt="Blacjack Apprenticeship Logo" />
            )}
          </Navbar.Brand>
          {props.authenticated ? (
            <>
              <Navbar.Toggle aria-controls="navbar-nav" />
              <Navbar.Collapse id="navbar-nav">
                <Nav className="ml-auto">
                  {!tracking ? (
                    <>
                      <Button
                        variant="warning"
                        size="sm"
                        className="my-3 my-lg-0"
                        onClick={track}
                      >
                        <FontAwesomeIcon
                          icon={['far', 'stopwatch']}
                          fixedWidth
                        />
                        TRACK SESSION
                      </Button>
                      <Navbar.Text className="d-none d-lg-inline-block mx-2">
                        |
                      </Navbar.Text>
                    </>
                  ) : null}
                  <Nav.Link as={Link} to={routes.sessions} onClick={close}>
                    <FontAwesomeIcon
                      icon={['far', 'clock']}
                      fixedWidth
                      className="mr-1"
                    />
                    SESSIONS
                  </Nav.Link>
                  <Navbar.Text className="d-none d-lg-inline-block mx-2">
                    |
                  </Navbar.Text>
                  <Nav.Link as={Link} to={routes.expenses} onClick={close}>
                    <FontAwesomeIcon
                      icon={['far', 'file-invoice-dollar']}
                      fixedWidth
                      className="mr-1"
                    />
                    EXPENSES
                  </Nav.Link>
                  <Navbar.Text className="d-none d-lg-inline-block mx-2">
                    |
                  </Navbar.Text>
                  <Nav.Link as={Link} to={routes.settings} onClick={close}>
                    <FontAwesomeIcon
                      icon={['far', 'cog']}
                      fixedWidth
                      className="mr-1"
                    />
                    SETTINGS
                  </Nav.Link>
                  <Navbar.Text className="d-none d-lg-inline-block mx-2">
                    |
                  </Navbar.Text>
                  <Nav.Link onClick={logout}>
                    <FontAwesomeIcon
                      icon={['far', 'sign-out']}
                      fixedWidth
                      className="mr-1"
                    />
                    LOG OUT
                  </Nav.Link>
                </Nav>
              </Navbar.Collapse>
            </>
          ) : null}
        </Container>
      </Navbar>
      {tracking && (
        <TrackingInfo
          tracking={tracking}
          onFinish={finish}
          onToggle={pauseOrResumeTracking}
        />
      )}
    </>
  )
}

Navigation.propTypes = {
  authenticated: PropTypes.bool.isRequired,
  incognito: PropTypes.bool.isRequired,
  onLogout: PropTypes.func.isRequired,
  pauseOrResumeTracking: PropTypes.func.isRequired,
  startTracking: PropTypes.func.isRequired,
  stopTracking: PropTypes.func.isRequired,
  tracking: PropTypes.array,
}

const mapState = state => ({
  incognito: state.settings.incognito,
  tracking: state.settings.tracking,
})

const mapDispatch = {
  pauseOrResumeTracking,
  startTracking,
  stopTracking,
}

export default connect(mapState, mapDispatch)(Navigation)
